<app-data-filters [disableSearch]="!(filters.loadNumbers?.length > 0) && !(filters.deliveryNumbers?.length > 0)"
                  [fullWidth]="true"
                  [opened]="true" #dataFilters>
    <app-data-filter-group [useAvailableWidth]="true">
        <app-data-filter-multi-string-input [labelKey]="'bluechat.search.filters.loadNumber'"
                                            [disabled]="filters.deliveryNumbers?.length > 0"
                                            [(model)]="filters.loadNumbers">
        </app-data-filter-multi-string-input>

        <app-data-filter-multi-string-input [labelKey]="'bluechat.search.filters.deliveryNumber'"
                                            [disabled]="filters.loadNumbers?.length > 0"
                                            [(model)]="filters.deliveryNumbers">
        </app-data-filter-multi-string-input>
    </app-data-filter-group>
    <app-data-filter-group [useAvailableWidth]="true">
        <app-data-filter-message [icon]="'fa-info-circle'" [labelKey]="'bluechat.search.criteria-limit'"></app-data-filter-message>
    </app-data-filter-group>
</app-data-filters>
